import React, { useState, useEffect } from "react";
import axios from "axios";
import '../css/adminEvent.css';
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const AdminEvent = () => {
  const [events, setEvents] = useState([]);
  const maxEvents = 14;
  const url = process.env.REACT_APP_BASE_URL;

  // Fetch all events from the database
  const fetchEvents = async () => {
    try {
      const response = await axios.get(`${url}/api/events/get`);
      if (response.status === 200) {
        setEvents(response.data.events); // Access the 'events' field of the response
      }
    } catch (error) {
      console.error("Error fetching events:", error);
      alert("Failed to load events. Please try again.");
    }
  };

  // Delete an event by ID
  const deleteEvent = async (id) => {
    try {
      const response = await axios.delete(`${url}/api/events/delete/${id}`);
      if (response.status === 200) {
 toast.success("Event deleted successfully.")
        setEvents(events.filter((event) => event._id !== id));
      }
    } catch (error) {
      console.error("Error deleting event:", error);
      alert("Failed to delete event. Please try again.");
    }
  };

  // Format date to "Month Day, Year" format
  const formatDate = (date) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(date).toLocaleDateString('en-US', options);
  };

  // Fetch events on component mount
  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Temple Events</h1>
        {/* events.length < maxEvents */}
        <Link to="/admin/dashboard/addEvent" >
          <button className={`${events.length > maxEvents ? "add-button-disable" :"add-button"}`}   disabled={events.length > maxEvents} >
            Add Event
          </button>
          </Link>
        
      </div>

      {/* Existing Events Table */}
   <div className="donation-table-container">
   <table className="event-table">
        <thead>
          <tr>
            <th>Sr.no</th>
            <th>Event Name</th>
            <th>Event Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event, index) => (
            <tr key={index}>
              <td>{index+1}</td>
              <td>{event.eventName}</td>
              <td>{formatDate(event.eventDate)}</td>
              <td>
                <button
                  className="delete-button"
                  onClick={() => deleteEvent(event._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
   </div>
    </div>
  );
};

export default AdminEvent;
